import { createContext } from "react";

const WorkoutContext = new createContext();

export default WorkoutContext;
